import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { State } from './type';
import { AnalyticsArticle } from '../../common/analytics/interfaces/analyticsArticle';

const initialState: State = { currentArticle: {} as AnalyticsArticle };
const hydrate = createAction<State & { content: State }>(HYDRATE);

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    updateCurrentArticle: (state, action: PayloadAction<AnalyticsArticle>) => {
      state.currentArticle = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(hydrate, (state, action) => {
      return { ...state, ...action.payload.content };
    });
  },
});

export const { updateCurrentArticle } = contentSlice.actions;

export default contentSlice.reducer;
